<template>
  <button
    type="button"
    v-tooltip="{
      content: shouldHideTooltip ? '' : title,
      placement: 'bottom',
      classes: 'w-tooltip w-tooltip--controls-without-text',
    }"
    class="
      try-new-teamwork-button
      bg-palette-purple-base
      hover:bg-palette-purple-base/75
      border-none
      text-white
      inline-flex
      items-center
      justify-center
      px-150
      h-[32px]
      text-[14px]
      outline-none
      cursor-pointer
      font-normal
      rounded-full
      font-sans
      space-between
    "
    :data-identifier="dataIdentifier"
    @click="$emit('click')"
  >
    <span class="try-new-teamwork-icon">
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.34452 0.474243H12.9755C13.4251 0.477537 13.8553 0.657615 14.1733 0.975533C14.4912 1.29345 14.6712 1.72369 14.6745 2.17328L14.6746 2.17786L14.6745 5.8212C14.6745 6.16638 14.3947 6.4462 14.0495 6.4462C13.7044 6.4462 13.4245 6.16638 13.4245 5.8212V2.18064C13.4232 2.06004 13.3747 1.94473 13.2894 1.85942C13.2041 1.7741 13.0887 1.7256 12.9681 1.72424H2.34729C2.22669 1.7256 2.11139 1.7741 2.02607 1.85942C1.94076 1.94473 1.89226 2.06004 1.8909 2.18063V11.2035C1.89226 11.3241 1.94076 11.4394 2.02607 11.5248C2.11139 11.6101 2.2267 11.6586 2.3473 11.6599H8.07319C8.41837 11.6599 8.69819 11.9397 8.69819 12.2849C8.69819 12.6301 8.41837 12.9099 8.07319 12.9099H2.33994C1.89035 12.9066 1.46011 12.7266 1.14219 12.4086C0.824273 12.0907 0.644212 11.6605 0.640918 11.2109L0.640884 11.2063L0.640901 2.17328C0.644195 1.72369 0.824273 1.29345 1.14219 0.975533C1.46011 0.657615 1.89035 0.477554 2.33994 0.47426L2.34452 0.474243Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.20486 0.83374C5.55004 0.83374 5.82986 1.11356 5.82986 1.45874V11.8375C5.82986 12.1826 5.55004 12.4625 5.20486 12.4625C4.85969 12.4625 4.57986 12.1826 4.57986 11.8375V1.45874C4.57986 1.11356 4.85969 0.83374 5.20486 0.83374Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.3049 9.3453C14.8753 9.07299 14.3767 8.92926 13.868 8.93105L13.8648 8.93105C13.3885 8.93033 12.9203 9.0546 12.507 9.29144C12.0937 9.52829 11.7497 9.86942 11.5095 10.2808C11.2693 10.6921 11.1412 11.1593 11.1381 11.6356C11.1349 12.112 11.2567 12.5808 11.4915 12.9953C11.7262 13.4099 12.0655 13.7555 12.4757 13.9979C12.8858 14.2402 13.3523 14.3707 13.8286 14.3763C14.3049 14.3819 14.7744 14.2625 15.1901 14.0299C15.6058 13.7973 15.9532 13.4597 16.1977 13.0509C16.3748 12.7546 16.7585 12.658 17.0548 12.8351C17.3511 13.0122 17.4477 13.396 17.2705 13.6923C16.9139 14.2888 16.407 14.7814 15.8004 15.1208C15.1938 15.4601 14.5088 15.6344 13.8139 15.6262C13.1189 15.618 12.4382 15.4276 11.8398 15.074C11.2414 14.7205 10.7462 14.2161 10.4037 13.6113C10.0613 13.0064 9.88346 12.3224 9.88809 11.6273C9.89271 10.9323 10.0796 10.2506 10.4301 9.65043C10.7806 9.05023 11.2824 8.55248 11.8855 8.2069C12.4881 7.86158 13.1706 7.68028 13.8651 7.68105C14.6117 7.67872 15.3434 7.88982 15.9741 8.28949C16.2656 8.47426 16.3522 8.86041 16.1674 9.15197C15.9826 9.44352 15.5965 9.53008 15.3049 9.3453Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.2794 7.54222C16.6218 7.49847 16.9348 7.74057 16.9785 8.08296L17.1623 9.52112C17.1834 9.68613 17.1378 9.85274 17.0357 9.98405C16.9336 10.1154 16.7833 10.2005 16.6182 10.2207L15.18 10.3965C14.8374 10.4384 14.5257 10.1946 14.4838 9.85193C14.4419 9.50931 14.6857 9.1976 15.0284 9.15573L15.8427 9.05619L15.7386 8.24139C15.6949 7.899 15.937 7.58597 16.2794 7.54222Z"
          fill="white"
        />
      </svg>
    </span>
    <span class="try-new-teamwork-text whitespace-nowrap">
      {{ title }}
    </span>
  </button>
</template>

<script>
import { useMediaQuery } from '@vueuse/core';

export default {
  name: 'TryNewTeamworkButton',
  props: {
    title: {
      type: String,
      default: '',
    },
    dataIdentifier: {
      type: String,
      default: 'header-try-new-teamwork-button',
    },
  },
  setup() {
    const shouldHideTooltip = useMediaQuery('(min-width: 1200px)');

    return {
      shouldHideTooltip,
    };
  },
};
</script>
<style scoped>
.try-new-teamwork-button {
  width: 32px;
  @media (min-width: 1200px) {
    width: 180px;
  }
}

.try-new-teamwork-text {
  display: none;

  @media (min-width: 1200px) {
    display: inline;
  }
}

.try-new-teamwork-icon {
  display: flex;
  align-items: center;

  @media (min-width: 1200px) {
    display: inline;
    margin: 5px 8px 0 0;
  }
}
</style>
